import React from 'react';
import { 
  Refresh 
} from '@mui/icons-material';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function RefreshButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <Refresh />
      </FabButton>
    );
  } else {
    return (
      <Button 
        disabled={disabled} 
        onClick={onClick} 
        variant="contained" color="primary">
        <Refresh />&nbsp;{ label }
      </Button>
    );
  }
}
